import React from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';

import { Theme } from '@constants';

const Rectangle = ({ x, y, width, height, color }) => (
  <View
    style={[
      styles.rectangle,
      {
        backgroundColor: color,
        left: x,
        top: y,
        width,
        height,
      },
    ]}
  />
);

Rectangle.propTypes = {
  color: PropTypes.string.isRequired,
  x: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  y: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export const TWCProgressBar = ({
  currentIncrement, // The tick mark the current bar is placed on (zero-indexed).
  totalIncrements, // The total number of tick marks.
  incrementColor, // The color of the increment tick marks.
  barColor, // The color of the progress bar.
  width,
  height,
  style,
}) => {
  const percentIncrement = totalIncrements > 1 ? 100 / (totalIncrements - 1) : 100;

  const incrementMarks = [];

  if (totalIncrements > 1) {
    for (let index = 0; index < totalIncrements; index++) {
      incrementMarks.push(
        <Rectangle
          key={`TWCProgressBar tick ${index}`}
          color={incrementColor}
          height={'100%'}
          width={Theme.px(1)}
          x={`${percentIncrement * index}%`}
          y={Theme.px(0)}
        />,
      );
    }
  }

  return (
    <View style={[style, { width, height }]}>
      {incrementMarks}
      <Rectangle
        key={'TWCProgressBar bar'}
        color={barColor}
        height={'100%'}
        width={`${percentIncrement * currentIncrement}%`}
        x={Theme.px(0)}
        y={Theme.px(0)}
      />
    </View>
  );
};

// TWCProgressBar.propTypes = {
//   currentIncrement: PropTypes.number.isRequired,
//   totalIncrements: PropTypes.number.isRequired,
//   incrementColor: PropTypes.string,
//   barColor: PropTypes.string,
//   width: PropTypes.number,
//   height: PropTypes.number,
//   style: PropTypes.oneOf([PropTypes.object, PropTypes.array]),
// };

TWCProgressBar.defaultProps = {
  incrementColor: Theme.progressBarMarkColor,
  barColor: Theme.progressBarColor,
  width: Theme.px(204),
  height: Theme.px(6),
  style: null,
};

const styles = StyleSheet.create({
  rectangle: {},
});
